/*
 *
 * SubrouteHeader
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 26-Nov-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { ArrowLeft, Dismiss } from '@nexidigital/iconlibrary'
import MerchantNavigationFlow from '@nexidigital/merchantnavigationflow'
import MerchantProgressBar from '@nexidigital/merchantprogressbar'
import { messages } from './languageModule'
import './SubrouteHeader.scss'

const SubrouteHeader = ({ title, onClose, closeLabel, onGoBack, goBackLabel, progress }) => {
  const enableClose = typeof onClose === 'function'
  const enableGoBack = typeof onGoBack === 'function'
  const intl = useIntl()

  const buttonsMap = {
    close: {
      iconCloseRight: <Dismiss size='20' type='line' />,
      labelButtonRight: closeLabel || intl.formatMessage(messages.close),
      onClickClose: (e) => onClose?.(e)
    },
    goBack: {
      iconCloseLeft: <ArrowLeft size='20' type='line' />,
      labelButtonLeft: goBackLabel || intl.formatMessage(messages.back),
      onClickBack: (e) => onGoBack?.(e)
    }
  }

  return (
    <Box className='subrouteHeaderWrapper'>
      <MerchantNavigationFlow
        title={title}
        childrenNav={!!progress && <MerchantProgressBar stepText={intl.formatMessage(messages.step)} {...progress} />}
        {...(enableClose && buttonsMap.close)}
        {...(enableGoBack && buttonsMap.goBack)}
      />
    </Box>
  )
}

export const SubrouteHeaderProps = {
  // Add here some propTypes
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClose: PropTypes.func,
  closeLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onGoBack: PropTypes.func,
  goBackLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  progress: PropTypes.shape({
    currentMiniStep: PropTypes.number,
    currentStep: PropTypes.number,
    labelStep: PropTypes.string,
    totalMiniSteps: PropTypes.number,
    totalSteps: PropTypes.number
  }),
}

SubrouteHeader.propTypes = SubrouteHeaderProps

SubrouteHeader.defaultProps = {
  // Add here some default propTypes values
  title: '-',
}

export default SubrouteHeader
